module.exports = __webpack_public_path__ + "img/bg3-3.4ae28e52.png";